import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=06c0a6a5"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"
import style0 from "./Signature.vue?vue&type=style&index=0&id=06c0a6a5&prod&lang=scss"
import style1 from "./Signature.vue?vue&type=style&index=1&id=06c0a6a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports